import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import config from '../config/site-config';
import SEO from '../components/SEO/SEO';

import '../styles/style.scss';
import '../styles/pages.scss';
import favicon from './favicon.png';
import appleTouchIcon from './apple-touch-icon.png';

import Menu from '../components/common/menu/Menu';
import Frame from '../components/common/frame/Frame';

const Layout = ({ children, location, data }) => {
    const { nav } = data.site.siteMetadata;
    const regPath = /\/(\w+)\//;
    let selected = regPath.exec(location.pathname);
    selected = selected === null ? '' : selected[1];
    console.log(selected);
    return (
        <React.Fragment>
            <Helmet bodyAttributes={{ class: 'landing' }}>
                <html lang={config.siteLanguage} />
                <meta charSet="utf-8" />
                <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
                <meta
                    name="viewport"
                    content="width=device-width, initial-scale = 1.0, maximum-scale=1.0"
                />
                <link rel="shortcut icon" href={favicon} />
                <link rel="apple-touch-icon" href={appleTouchIcon} />
                <title>{config.siteTitle}</title>
            </Helmet>
            <SEO />
            {children()}
            <Frame />
            <Menu links={nav} selected={selected} fixedBottom />
        </React.Fragment>
    );
};

Layout.propTypes = {
    children: PropTypes.func.isRequired,
};

export default Layout;

/* eslint no-undef: "off" */
export const pageQuery = graphql`
    query landingQuery {
        site {
            siteMetadata {
                siteUrl
                nav
            }
        }
    }
`;



// WEBPACK FOOTER //
// ./src/layouts/landing.jsx